import { render, staticRenderFns } from "./product-weight-manage-modal.vue?vue&type=template&id=64f512a2&"
import script from "./product-weight-manage-modal.vue?vue&type=script&lang=js&"
export * from "./product-weight-manage-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports